import { inject, Injectable, OnDestroy } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ReplaySubject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { AllDeviceInfo } from '@interfaces';
import { DeviceInfoService } from '@core/services/device-info.service';
import { EnableMfaModalComponent, EnableMfaModalData, EnableMfaModalResult } from './enable-mfa-modal.component';

@Injectable()
export class EnableMfaModalService implements OnDestroy {
  private readonly dialog = inject(MatDialog);
  private readonly deviceInfoService = inject(DeviceInfoService);

  public dialogRef: MatDialogRef<EnableMfaModalComponent, EnableMfaModalResult>;
  public name = 'enable-mfa-modal';

  private destroy$ = new ReplaySubject<boolean>(1);

  public deviceInfo: AllDeviceInfo;
  private dialogWidth = '560px';
  private dialogHeight = 'auto';

  constructor() {
    this.deviceInfo = this.deviceInfoService.getInfo();
    this.deviceInfoService.infoEmitter.pipe(takeUntil(this.destroy$)).subscribe(info => {
      this.deviceInfo = info;
      this.setDialogDimensions();
    });

    this.setDialogDimensions();
  }

  public open(data: EnableMfaModalData): MatDialogRef<EnableMfaModalComponent, EnableMfaModalResult> {
    this.dialogRef = this.dialog.open(EnableMfaModalComponent, {
      width: this.dialogWidth,
      maxWidth: this.dialogWidth,
      height: this.dialogHeight,
      panelClass: ['enable-mfa-modal'],
      autoFocus: false,
      data,
      id: this.name,
      backdropClass: this.name + '_backdrop',
    });

    return this.dialogRef;
  }

  public ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  private setDialogDimensions(): void {
    if (this.deviceInfo?.deviceTypeDetected === 'PHONE') {
      this.dialogWidth = '95vw';
      this.dialogHeight = '95dvh';
      return;
    }

    this.dialogWidth = '560px';
    this.dialogHeight = 'auto';
  }
}
